module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#intro"
    }
  }, [_vm._v("Introduction: Faces of Tradition in Chinese Performing Arts / Levi S. Gibbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ch1"
    }
  }, [_c('b', [_vm._v("1")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Grasping Intangible Heritage and Reimagining Inner Mongolia: Folk-Artist Albums and a New Logic for Musical Representation in China / Charlotte D’Evelyn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Chinese Singing Contests as Sites of Negotiation among Individuals and Traditions / Levi S. Gibbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Dynamic Inheritance: Representative Works and the Authoring of Tradition in Chinese Dance / Emily E. Wilcox")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Collecting Flowers, Defining a Genre: Zhang Yaxiong and the "), _c('i', [_vm._v("Anthology of Hua’er Folksongs")]), _vm._v(" / Sue Tuohy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("From Field Recordings to Ethnographically Informed CDs: Curating the Sounds of Yunnan for a Niche Foreign Market / Helen Rees")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "rglo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Glossary#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of Selected Chinese Terms and Phrases")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c47215","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0